var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-header"},[_vm._m(0),_c('div',{staticClass:"header-right"},[_c('div',{staticClass:"user-role"},[_vm._v(_vm._s(_vm.$t('user.role')[_vm.user.data.role]))]),_c('Notifications'),_c('user-menu')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-left"},[_c('div',{staticClass:"logo"},[_c('a',[_c('img',{attrs:{"src":require("@/assets/logo.svg"),"alt":"Index"}})])])])
}]

export { render, staticRenderFns }